import {
  alpha,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useTheme
} from '@mui/material';
import LogoCard from '../LogoCard';
import { COPY } from '../../constants';

const FullAppFallback = () => {
  const theme = useTheme();
  const clearBlue = alpha(theme.palette.info.light, 0.1);

  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box
      component={'main'}
      sx={{
        gridArea: 'main',
        backgroundColor: clearBlue
      }}>
      <Container
        sx={{
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <LogoCard>
          <Grid
            size={12}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <Typography variant="h5" sx={{ padding: 3 }}>
              {COPY.fallback.header}
            </Typography>
            <Typography variant="body1">{COPY.fallback.fullAppExplanation}</Typography>
            <Button
              onClick={() => handleRetry()}
              color="primary"
              variant="contained"
              disableElevation
              sx={{ borderRadius: 3, margin: 3, fontSize: '10pt' }}
            >
              {COPY.fallback.fullAppButton}
            </Button>
            <Typography variant="caption">
              {COPY.fallback.fullAppFallbackContact}
              <Link href="mailto:support@surepass.com" underline="hover">
                {COPY.fallback.supportEmail}
              </Link>
            </Typography>
          </Grid>
        </LogoCard>
        <Typography
          variant="caption"
          sx={{
            paddingY: 1,
            color: theme.palette.grey[600],
            paddingTop: 2
          }}>
          {COPY.copyrightFooter}
        </Typography>
      </Container>
    </Box>
  );
};

export default FullAppFallback;
